export default __webpack_public_path__ + "static/media/folderIcon.0c31484f.svg";